<!-- 消息设置 -->
<template>
    <div class="out_wrap">
        <el-form label-width="200px">
            <el-form-item label="预警消息开关：" prop="ew_status" class="blance_lable">
                <el-switch v-model="form.ew_status" :active-value="1" :inactive-value="2" active-color="#2d8cf0"
                    inactive-color="#C0CCDA" @change='changeSwitch($event,form)'></el-switch>
            </el-form-item>
        </el-form>
        <el-form label-width="200px">
            <el-form-item label="预警金额：" prop="ew_type">
                <div>
                    <el-radio-group v-model="form.ew_type">
                        <el-radio :label="1">连续有效流水三天平均</el-radio>
                    </el-radio-group>
                    <el-tooltip effect="dark" content="当天往前取有效流水的三个日期，算出这三个日期的平均值作为预警金额" placement="top">
                        <i class="el-icon-warning c6 ml5" />
                    </el-tooltip>
                </div>
                <div class="flex_middle mt20">
                    <div class="mr30">
                        <el-radio-group v-model="form.ew_type">
                            <el-radio :label="2">自定义金额</el-radio>
                        </el-radio-group>
                        <el-tooltip effect="dark" content="低于自定义金额触发预警" placement="top">
                                <i class="el-icon-warning c6 ml5" />
                            </el-tooltip>
                    </div>
                    <div v-if="form.ew_type == 2">
                        <el-input placeholder="请输入自定义金额" clearable v-model="form.ew_price" type="text" @input="form.ew_price = form.ew_price.replace(/\D/g, '')"></el-input>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="预警频次：" prop="ew_status">
                <el-select v-model="form.ew_times" class="selectWith120" placeholder="请选择">
                    <el-option v-for="(item) in timeArr" :key="item.id" :label="item.text" :value="item.id" />
                </el-select>
                <span class="ml20">小时/次</span>
            </el-form-item>
            <el-form-item class="mt80">
                <el-button type="primary" @click="save">保存配置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { getEwconfig, setEwconfig } from '@/api/set'
export default {
  data() {
    return {
      tableData: [],
      form: {
        ew_type: '', //预警类型 1三日平均 2自定义金额
        ew_status: '', //预警状态 1开启 2关闭
        ew_price: 0, //自定义金额（分）
        ew_times: 1, //预警间隔（小时）
      },
      timeArr:[
        {
            text:'1',
            id: 1
        },
        {
            text:'2',
            id: 2
        },
        {
            text:'3',
            id: 3
        },
        {
            text:'4',
            id: 4
        },
        {
            text:'5',
            id: 5
        },
        {
            text:'6',
            id: 6
        },
        {
            text:'7',
            id: 7
        },
        {
            text:'8',
            id: 8
        },
        {
            text:'9',
            id: 9
        },
        {
            text:'10',
            id: 10
        },
        {
            text:'仅触发一次',
            id: -1
        }
      ]
    }
  },
  mounted() {
    this.query()
  },
  methods: {
      query() {
          getEwconfig().then(res => {
              if (res.code === 200) {
                this.form = {...res.data,ew_price:this.$formatCurrency(res.data.ew_price)}
              }
          })
      },
      changeSwitch(value,item) {
      let text = ''
      if (value == 2) {
       text = '关闭将收不到消息通知，您是否要关闭预警金额配置？'
      }else{
       text = '开启可以收到消息通知，您是否要开启预警金额配置？'
      }
      item.ew_status  = item.ew_status == 1 ? 2 : 1
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //点击确定执行的逻辑
        item.ew_status  = item.ew_status == 1 ? 2 : 1
      }).catch(() => {

        });
    },
    save(){
        if(this.form.ew_type == 2 && +!this.form.ew_price){
         this.$message('请输入自定义金额')
         return
        }
        var data = {
          ew_type: this.form.ew_type,
          ew_status: this.form.ew_status,
          ew_times: this.form.ew_times
        }
        if(this.form.ew_type == 2){
          data.ew_price = +this.form.ew_price
        }
        setEwconfig(data).then(res => {
          if(res.code === 200){
            this.$message.success('配置成功')
            this.query()
          }
        })
    },
  }
}
</script>
<style lang='scss' scoped>
.mt80{
    margin-top: 80px;
}
::v-deep{
.blance_lable .el-form-item__label{
    font-size: 16px;
}
}
.el-input{
    width: 300px;
}
.el-select {
    width: 300px;
}
</style>
